import { Image, Text, View, StyleSheet, Font } from "@react-pdf/renderer";
import akanthasLogo from "../../../static/assets/logo_rvg.png";
import wasteQualityLogo from "../../../static/assets/waste_quality_logo.png";
import MulishLight from "../../../static/fonts/Mulish/Mulish-Light.ttf";
import MulishMedium from "../../../static/fonts/Mulish/Mulish-Medium.ttf";
import ShowClientLogo from "./ClientLogo";
import { useTranslation } from "react-i18next";

Font.register({
  family: "Mulish",
  fonts: [
    { src: MulishLight, fontWeight: 200 },
    { src: MulishMedium, fontWeight: 500 },
  ],
});

const styles = StyleSheet.create({
  header: {
    backgroundColor: "#f0f0f0",
    width: "100%",
    flexDirection: "column",
    paddingTop: 6,
    paddingBottom: 6,
  },
  logos: {
    marginTop: "36px",
    height: 26,
    width: "100%",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
  },
  logoBox: {
    width: 200,
    height: 26,
    justifyContent: "center",
    alignItems: "center",
    marginHorizontal: 5,
  },
  logoImage: {
    height: "100%",
    objectFit: "contain",
  },
  logoImageBoost: {
    height: "110%",
    marginVertical: -3,
  },
  logoAndTitle: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 6,
    flexShrink: 0,
  },
  wasteQualityLogo: {
    width: 80,
    height: 64,
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: 12,
  },
  titleAndDateTime: {
    flex: 1,
    paddingLeft: 12,
  },
  title: {
    fontSize: 20,
    color: "#0F265C",
    fontFamily: "Mulish",
    fontWeight: 500,
    letterSpacing: "1px",
  },
});

const HeaderWasteQualityPDF = ({ logoUrl }) => {
  const { t } = useTranslation();

  return (
    <View style={styles.header}>
      <View style={styles.logos}>
        <View style={styles.logoBox}>
          <Image style={styles.logoImage} src={akanthasLogo} />
        </View>
        {logoUrl ? (
          <View style={styles.logoBox}>
            {ShowClientLogo(logoUrl, [styles.logoImage, styles.logoImageBoost])}
          </View>
        ) : null}
      </View>

      <View style={styles.logoAndTitle}>
        <View style={styles.wasteQualityLogo}>
          <Image src={wasteQualityLogo} />
        </View>

        <View style={styles.titleAndDateTime}>
          <Text style={styles.title}>{t("My characterization report")}</Text>
        </View>
      </View>
    </View>
  );
};

export default HeaderWasteQualityPDF;
